import { Subject } from "../models/subject";

export const hasSameMappingId = (mappingId1: any, mappingId2: any) => {
  if (!mappingId1 || !mappingId2) return false;
  if (
    !mappingId1[0] &&
    !mappingId2[0] &&
    mappingId1.toUpperCase &&
    mappingId2.toUpperCase &&
    mappingId1.toUpperCase() !== mappingId2.toUpperCase()
  )
    return false;
  if (
    !mappingId1[0] &&
    !mappingId2[0] &&
    mappingId1.toUpperCase &&
    mappingId2.toUpperCase &&
    mappingId1.toUpperCase() === mappingId2.toUpperCase()
  )
    return true;
  if (!mappingId1[0] || !mappingId2[0]) return false;
  for (let id1 of mappingId1) {
    let findId = mappingId2.find(
      (id: string) => id.toUpperCase() === id1.toUpperCase()
    );
    if (!findId) return false;
  }
  return true;
};

const subjectEquals = (subject1: Subject, subject2: Subject) => {
  return (
    subject1.id === subject2.id ||
    hasSameMappingId(subject1.mappingId, subject2.mappingId)
  );
};

export default subjectEquals;
